import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {Chip} from "@mui/material";
import {cancelChipStyle} from "../../ButtonStyle/Cancel";
import {addChipStyle} from "../../ButtonStyle/Add";
import ReceiptsAddNewCard from "./ReceiptsAddNewCard";
import ReceiptsEditCard from "./ReceiptsEditCard";


function ReceiptEdit(props){

    const navigate = useNavigate();

    const [ receipt, setReceipt ] = useState(props.receiptToEdit)
    useEffect(() => {
        console.log("receiptToEdit has been triggered");
        //a different receipt to edit
        if (props.receiptToEdit.id !== receipt.id){
            setReceipt(props.receiptToEdit);
        }
    }, [props.receiptToEdit]);

    useEffect(() => {
        console.log("sending up ... props.handleReceiptUpdates");
        props.handleReceiptUpdates(receipt);
    }, [receipt]);

    function updateReceipt(updatedReceipt){
        console.log("updateReceipt");
        setReceipt(updatedReceipt);
    }

    function handleReceiptsEditDone(){
        props.setShowEventItemExtendedConfig(false);
        navigate("/Planner/Receipts");
    }


    return (

        <div className="receipts-list-container" >
            {/* show the header */}
            <div
                className="receipts-list-header"
            >
                <div className="receipts-list-header-text">
                    <h5>Edit Receipt</h5>
                </div>
                <div className="receipts-list-header-chip-holder">
                    <Chip
                        sx={addChipStyle}
                        label="Done"
                        size="small"
                        onClick={handleReceiptsEditDone}
                    />
                </div>
            </div>

            <div
                className="receipt-edit-item-container"
                style={{height: 'calc(100vh - 300px)', overflow: 'auto'}}
            >
                <ReceiptsEditCard
                    receipt={receipt}
                    updateReceipt={updateReceipt}
                />
            </div>
        </div>
    )
}

export default ReceiptEdit